import { AdminAppState } from '../../../state';
import { Location } from 'history';
import React from 'react';
import { getLocation } from 'connected-react-router';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Iframe = styled.iframe`
  border: 0;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 0;
`;

export const AdminSiteViewportIframe = React.memo(
  () => {
    // TODO: we probably want to memoize this so the iframe is only rendered once!
    const location: Location = useSelector<AdminAppState, any>(
      getLocation,
      () => true,
    );

    const url = new URL(location.pathname, 'https://itdoesntmatter.com');

    if (!url.searchParams.has('viewport')) {
      url.searchParams.set('viewport', 'true');
    }

    return <Iframe id="viewport" src={url.pathname + url.search} />;
  },
  () => true,
);

AdminSiteViewportIframe.displayName = 'AdminSiteViewportIframe';
